import RenderManager from "../rendering/render-manager";
import Utils from "../utils";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import Base2DElement from "./base-2d-element";
import Transition from "./Transition";

class Slider extends Base2DElement {
    get type2d() { return "Slider"; }

    _createContainer() {
        const container = super._createContainer();

        container.className = 'slider-container';

        return container;
    }

    _initDefaultVars() {
        super._initDefaultVars();
        this._draggable = true;
    }

    get draggable() { return this._draggable; }
    set draggable(val) { this._draggable = val; }

    _initValues(options) {
        /* SPECIFIC 2D ELEMENTS PARAMETERS */

        let initialData = {
            x: this._xy.x, y: this._xy.y,
            width: this._wh.x, height: this._wh.y,
            orientation: "orientation" in options ? options.orientation : "horizontal",
        };

        this._sizeSm = JSON.parse(JSON.stringify("sizeSm" in options ? options.sizeSm : initialData));
        this._sizeLg = JSON.parse(JSON.stringify("sizeLg" in options ? options.sizeLg : initialData));

    }

    constructor(options, parentLayer, uuid) {
        super(options, parentLayer, uuid);
        this.size = 30;
        this.sliderBg = document.createElement('div');
        this.sliderBg.className = 'slider-bg';
        this.createSliderElement();
        this.domElement.appendChild(this.sliderElement);
        this.domElement.appendChild(this.sliderBg);
        this.createCircularSlider().then(() => {
            this.slideListeners = [];
            if (Q3.isReady) {
                this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                this.enterExitCtrl.init(options);
            } else {
                Q3.Events.listen("tourReady", () => {
                    this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                    this.enterExitCtrl.init(options);
                })
            }

            this.addActions();
            this.addScriptListener();

            if (Q3.editMode) {
                this.domElement.addEventListener('click', e => {
                    this.selectHandler(e);
                }, false);
            }
            this.updateSliderStyle();

            this.redraw = this.redraw.bind(this);

            this.handleListeners(true);

            this.redraw();
            Q3.Events.fire('updateresizer');
        });

    }

    addActions() {
        this.slideListeners.forEach(l => {
            this.sliderElement.removeEventListener(l.type, l.handler);
        });
        this.slideListeners = [];
        const action = (this.data || {}).action;
        if (!action) return;

        for (let i = 0; i < action.length; i++) {
            const currAction = action[i];
            let userAction = currAction.userAction;

            //define a transition

            const transition = new Transition(currAction.systemAction, currAction.value);

            if (userAction === 'slide') {

                let listener = function (e) {
                    transition.slide(e.detail);
                };
                this.slideListeners.push({ type: "slide", handler: listener });
                this.sliderElement.addEventListener('slide', listener, false);

            } else if (userAction === 'click') {

                const transition = new Transition(currAction.systemAction, currAction.value);

                let listener = function (e) {
                    transition.slide(e);
                    // previously "e.detail" came to the parameters
                };

                this.slideListeners.push({ type: "click", handler: listener });
                this.domElement.addEventListener('mousedown', listener, false);

            } else {

            }

        }
    }

    addScriptListener() {
        const parentLayerUuid = this.parentLayer.uuid;
        let listener = function (e) {
            Events.fire("slidermoved", { uuid: parentLayerUuid, value: e.detail });
        };

        this.slideListeners.push({ type: "slide", handler: listener });
        this.sliderElement.addEventListener('slide', listener, false);
    }

    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
        Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
    }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    render(width, height) {
        if (!Q3.data.layers.layers2D[this.parentLayer.uuid] || this.disabled || Utils.queryParams.has("disable_2d")) return;

        if (!this.isMounted || this.target) {
            this.redraw(width, height);
            if (width > 0 && height > 0) {
                this.isMounted = true;
            }
        }
    }

    redraw(width, height) {

        if (!width) width = RenderManager.domElement.width / RenderManager.pixelRatio;
        if (!height) height = RenderManager.domElement.height / RenderManager.pixelRatio;

        if (!Q3.editMode && this.inLetterbox !== false) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        let currentSize = this.getVWSize();
        if (this[currentSize]) {
            Object.assign(this.options, this[currentSize]);
        }

        let orientation = this.options.orientation || 'horizontal';
        switch (orientation) {
            case 'horizontal':
                this.sliderElement.style.flexDirection = 'row';
                this.sliderElement.style.height = "0.6rem";
                this.sliderElement.style.width = this.options.width / 100 * width * RenderManager.pixelRatio + 'px';
                break;
            case 'vertical':
                this.sliderElement.style.flexDirection = 'column';
                this.sliderElement.style.width = "0.6rem";
                this.sliderElement.style.height = this.options.width / 100 * height * RenderManager.pixelRatio + 'px';
                break;
        }
        let x, y;
        x = this.x * width * RenderManager.pixelRatio;
        y = this.y * height * RenderManager.pixelRatio;
        this.domElement.style.position = "absolute";

        this.domElement.style.position = "absolute";
        this.domElement.style.top = y + 'px';
        this.domElement.style.left = x + 'px';

        if (this.objChanged) {
            Events.fire("objchanged");
            this.objChanged = false;
        }

        this.updateSliderStyle();
    }

    updateSliderStyle() {

        if (this.sliderElement) {

            let orientation = this.options.orientation || 'horizontal';
            let marginSize = -this.size / 2 / 15.5 + 'rem';
            let sliderElement = this.sliderElement;
            let thumbElement = this.thumbElement;

            if (orientation === 'horizontal') {
                thumbElement = this.thumbElement;
                sliderElement = this.sliderElement;
                thumbElement.style.marginLeft = marginSize;
                thumbElement.style.marginBottom = '';
                this.sliderBg.style.width = "calc(100% + " + this.size / 15.5 * 2 + "rem)";
                this.sliderBg.style.height = "120%";
                this.sliderElement.style.display = "inline-flex";
                if (this.circularSliderElement)
                    this.circularSliderElement.style.display = "none";
                sliderElement.style.background = this.options.borderColor;
                this.sliderBg.style.display = "block";
            } else if (orientation === 'vertical') {
                thumbElement = this.thumbElement;
                sliderElement = this.sliderElement;
                thumbElement.style.marginLeft = '';
                thumbElement.style.marginBottom = marginSize;
                thumbElement.style.left = 'unset';
                this.sliderBg.style.width = "120%";
                this.sliderBg.style.height = "calc(100% + " + this.size / 15.5 * 2 + "rem)";
                this.sliderElement.style.display = "inline-flex";
                if (this.circularSliderElement)
                    this.circularSliderElement.style.display = "none";
                sliderElement.style.background = this.options.borderColor;
                this.sliderBg.style.display = "block";
            } else if (this.circularSliderElement) {
                sliderElement = this.circularSliderElement;
                let min = 0;
                let max = 1000;
                if (this.options.inverted) {
                    [min, max] = [max, min];
                }
                $(sliderElement).roundSlider("option", "min", min);
                $(sliderElement).roundSlider("option", "max", max);
                $(sliderElement).roundSlider("option", "showTooltip", this.options.showLabel || false);
                $(sliderElement).roundSlider("option", "tooltipColor", this.options.labelColor || "#ffffff");
                $(sliderElement).roundSlider("option", "max", max);
                $(sliderElement).roundSlider("setValue", 0);
                thumbElement = sliderElement.querySelector(".rs-handle");
                this.sliderBg.style.display = "none";
                this.sliderElement.style.display = "none";
                this.circularSliderElement.style.display = "inline-flex";
                $(thumbElement).css("transform", "translate(-20%, -50%)");
                $(thumbElement).css("margin", "0");
                $(sliderElement).css("width", this.size / 2 + 'rem').css("height", this.size / 2 + 'rem');
                $(sliderElement).find(".rs-container.rs-full").css("width", this.size / 2 + 'rem').css("height", this.size / 2 + 'rem');
                $(sliderElement).find(".rs-block").css("padding", this.size / 15.5 / 2 + 'rem');
                $(sliderElement).find(".rs-block.rs-outer").css("padding", "0").css("border", "none");
                $(sliderElement).find(".rs-block .rs-inner").css("border", "1px solid rgba(0, 0, 0, 0.2)");
                let borderColor = this.options.borderColor;
                let color = this.options.color;
                if (this.options.inverted) {
                    [borderColor, color] = [color, borderColor]
                }
                $(sliderElement).find(".rs-range-color").css("background", color);
                $(sliderElement).find(".rs-path-color").css("background", borderColor);
                $(sliderElement).find(".rs-bg-color").css("background", this.options.backgroundColor || "#24007b");
                $(sliderElement).find(".rs-start, .rs-end").css("display", "none");

            }

            thumbElement.style.background = this.options.color;
            thumbElement.style.width = this.size / 15.5 + 'rem';
            thumbElement.style.height = this.size / 15.5 + 'rem';
            thumbElement.style.borderRadius = this.options.radius / 30 * 50 + '%';
            thumbElement.style.borderWidth = this.options.border / 15.5 + 'rem';
            thumbElement.style.borderStyle = 'solid';
            thumbElement.style.zIndex = this.options.border ? 2 : 0;
            thumbElement.style.borderColor = this.options.borderColor;
            this.sliderRange.style.background = this.options.color;
            this.sliderBg.style.borderRadius = this.size / 15.5 + 'rem';
            // if (Q3.editMode) {
            let p = (this.size / 2 + 3) / 15.5 + "rem";
            if (orientation === 'horizontal') {
                this.domElement.style.padding = p + " 0";
            } else if (orientation === 'vertical') {
                this.domElement.style.padding = "0 " + p;
            } else {
                this.domElement.style.padding = 0;
            }
            // }
            if (Q3.editMode) {
                $(this.sliderElement).slider("option", "orientation", orientation);
                $(this.sliderElement).slider({ value: $(this.sliderElement).slider("option", this.options.inverted ? "max" : "min") })
            }
        }
    }

    createSliderElement() {
        if (!this.sliderElement) {
            this.sliderElement = document.createElement('div');
            this.sliderElement.style.display = "inline-flex";
            this.sliderElement.style.alignItems = "center";
            this.sliderElement.style.pointerEvents = "auto";
            this.sliderElement.style.borderRadius = "1rem";

            this.domElement.innerHTML = "";
            this.domElement.appendChild(this.sliderElement);

            this.thumbElement = document.createElement('div');
            this.thumbElement.style.position = 'absolute';
            this.thumbElement.className = 'ui-slider-handle';

            this.sliderElement.appendChild(this.thumbElement);

            let min = 0;
            let max = 1000;
            let initialValue = this.options.inverted ? max : min;

            if (!Q3.editMode && this.data.action && this.data.action.length) {
                if (this.data.action.filter(a => a.systemAction === 'setgraph').length) {
                    initialValue = 500;
                }
            }

            $(this.sliderElement).slider({
                range: "min",
                orientation: this.options.orientation || 'horizontal',
                value: initialValue,
                min: min,
                max: max,
                step: 1,
                start: (event, ui) => {
                    Q3.Analytics.add({
                        type: 'sliderevent',
                        eventName: "start",
                        sliderName: this.parentLayer.name,
                        value: this.options.inverted ? 1000 - ui.value : ui.value
                    })
                },
                stop: (event, ui) => {
                    Q3.Analytics.add({
                        type: 'sliderevent',
                        eventName: "stop",
                        sliderName: this.parentLayer.name,
                        value: this.options.inverted ? 1000 - ui.value : ui.value
                    })
                },
                slide: (event, ui) => {
                    const e = new CustomEvent('slide', { detail: this.options.inverted ? 1 - ui.value / 1000 : ui.value / 1000 });
                
                    this.sliderElement.dispatchEvent(e);
                }
            });


            this.sliderRange = this.sliderElement.querySelector(".ui-slider-range");

        }
    }

    createCircularSlider() {
        return new Promise(resolve => {
            if (Q3.editMode || this.options.orientation === "circular") {
                awaitLib().then(() => {
                    this.circularSliderElement = document.createElement('div');
                    this.circularSliderElement.style.display = "none";
                    this.circularSliderElement.style.alignItems = "center";
                    this.circularSliderElement.style.pointerEvents = "auto";
                    this.circularSliderElement.style.borderRadius = "1rem";

                    this.domElement.appendChild(this.circularSliderElement);

                    this.cicularThumbElement = document.createElement('div');
                    this.cicularThumbElement.style.position = 'absolute';
                    this.cicularThumbElement.className = 'ui-slider-handle';

                    this.circularSliderElement.appendChild(this.cicularThumbElement);

                    let initialValue = 0;
                    if (!Q3.editMode && this.data.action && this.data.action.length) {
                        if (this.data.action.filter(a => a.systemAction === 'setgraph').length) {
                            initialValue = 500;
                        }
                    }
                    let min = 0;
                    let max = 1000;
                    if (this.options.inverted) {
                        [min, max] = [max, min];
                    }
                    $(this.circularSliderElement).roundSlider({
                        min: min,
                        max: max,
                        step: 1,
                        value: initialValue,
                        handleSize: "+0",
                        startAngle: 0,
                        endAngle: "+360",
                        animation: true,
                        editableTooltip: false,
                        readOnly: false,
                        disabled: false,
                        keyboardAction: true,
                        mouseScrollAction: false,
                        sliderType: "min-range",
                        circleShape: "full",
                        handleShape: "round",
                        lineCap: "butt",

                        // the 'startValue' property decides at which point the slider should start.
                        // otherwise, by default the slider starts with min value. this is mainly used
                        // for min-range slider, where you can customize the min-range start position.
                        startValue: null,

                        // SVG related properties
                        svgMode: false,
                        borderWidth: 1,
                        borderColor: null,
                        pathColor: null,
                        rangeColor: this.options.color,
                        showTooltip: this.options.showLabel || false,
                        tooltipColor: this.options.labelColor || "#ffffff",

                        // events
                        beforeCreate: null,
                        create: (e) => {
                            setTimeout(() => {
                                this.updateSliderStyle();
                            }, 200)
                        },
                        start: (event) => {
                            Q3.Analytics.add({
                                type: 'sliderevent',
                                eventName: "start",
                                sliderName: this.parentLayer.name,
                                value: this.options.inverted ? 1000 - event.value : event.value
                            })
                        },
                        drag: (event) => {
                            const e = new CustomEvent('slide', { detail: event.value / 1000 });
                            this.sliderElement.dispatchEvent(e);
                        },
                        stop: (event) => {
                            Q3.Analytics.add({
                                type: 'sliderevent',
                                eventName: "stop",
                                sliderName: this.parentLayer.name,
                                value: this.options.inverted ? 1000 - event.value : event.value
                            })
                        },
                        tooltipFormat: (args) => {
                            return args.value / 1000;
                        }
                    });
                    this.circularSliderRange = this.circularSliderElement.querySelector(".ui-slider-range");
                    this.domElement.appendChild(this.circularSliderElement);
                    resolve();
                })
            } else {
                resolve();
            }
        })


    }

    setData(data) {
        this.setOptions({ x: data.x, y: data.y });
    }

    getRenderPositionAndSize(width, height) {
        let { x, y, w, h } = super.getRenderPositionAndSize(width, height);
        let rect = this.domElement.getBoundingClientRect();
        return { x, y, w: rect.width, h: rect.height }

    }
    setOptions(data) {
        const objectData = this.data;
        const currentSize = this.getVWSize();

        const orientationDependent = { x: true, y: true, size: true, width: true, orientation: true };

        const sizeAssignData = {};
        for (let name in data) {
            if (orientationDependent[name]) {
                sizeAssignData[name] = data[name];
            } else {
                this.options[name] = data[name];
            }
        }

        Object.assign(this[currentSize], sizeAssignData);

        if (!objectData[currentSize]) {
            objectData[currentSize] = {};
        }

        Object.assign(objectData[currentSize], sizeAssignData);

        this.redraw();
    }


    delete() {

        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
        this.parentLayer.domElement.removeChild(this.domElement);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

    set x(val) { this.options.x = val; }
    set y(val) { this.options.y = val; }
    get x() { return this.options.x; }
    get y() { return this.options.y; }

    get width() {
        return this.domElement.offsetWidth / Q3.container.offsetWidth;
    }

    get height() {
        return this.domElement.offsetHeight / (Q3.container.offsetHeight);
    }
}

export default Slider;
export { Slider };

const awaitLib = (function () {
    let promise;
    return function () {
        return promise = (promise || new Promise(resolve => {
            console.warn("Begun downloading RoundSlider");
            injectJS("/lib/roundSlider/roundslider.min.js").then(function () {
                console.info("RoundSlider lib downloaded.");
                resolve();
            });
        }));
    };
})();
